// libs
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useLocation } from 'react-router-dom';
// widgets
import StepNavigator from '../StepNavigator';
import StickyFooter from '../StickyFooter/StickyFooter';
// styles
import style from './Stepper.module.scss';
const Stepper = forwardRef(({ steps }, ref) => {
    const location = useLocation();
    const [activeStep, setActiveStep] = useState(() => {
        var _a;
        const value = (_a = location.state) === null || _a === void 0 ? void 0 : _a.activeStep;
        return value ? Number(value) : 0;
    });
    useImperativeHandle(ref, () => ({
        setActiveStep: (step) => {
            setActiveStep(step);
        },
    }), []);
    const handleNext = () => {
        const { validator, action } = steps[activeStep];
        const validationPassed = typeof validator === 'function' ? validator() : true;
        if (!validationPassed) {
            return;
        }
        const actionPromise = typeof action === 'function' ? action() : Promise.resolve(true);
        return actionPromise.then((proceed) => {
            if (proceed && activeStep !== steps.length - 1) {
                setActiveStep(activeStep + 1);
            }
        });
    };
    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        }
    };
    const isLastStep = activeStep === steps.length - 1;
    const nextButtonLabel = isLastStep ? 'Submit Campaign' : 'Next';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: style.container },
            React.createElement("div", { className: style.navigator },
                React.createElement(StepNavigator, { steps: steps, activeStep: activeStep, setActiveStep: setActiveStep })),
            React.createElement("div", null, steps[activeStep].component)),
        React.createElement(StickyFooter, { showBack: activeStep > 0, onBack: handleBack, onNext: handleNext, backButtonLabel: "Back", nextButtonLabel: nextButtonLabel })));
});
export default Stepper;
